import React from "react";
import {useProductSelector} from "../../../stores/product/product.store";
import {ProductState} from "../../../stores/product/product-state.interface";

interface NotificationProps {
    onClick: () => void;
}

export const Notification: React.FC<NotificationProps> = ({ onClick }) => {
    const translate = useProductSelector((state: ProductState) => state.translate);

    return (
        <>
            <button
                onClick={ onClick }
                className="flex justify-center items-center bg-yellow text-[16px] font-bold w-full rounded-2xl p-4 mb-4">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M6.49398 13V9C6.49398 5.686 9.18298 3 12.5 3C15.817 3 18.506 5.686 18.506 9V13C18.506 13.986 18.954 14.919 19.723 15.537L20.032 15.785C20.949 16.521 20.428 18 19.252 18H5.74798C4.57198 18 4.05098 16.521 4.96798 15.785L5.27698 15.537C6.04698 14.919 6.49398 13.986 6.49398 13Z"
                          stroke="#12100B" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M11 22.0005H14" stroke="#12100B" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
                { translate.notificationInStock }
            </button>
        </>
    )
}